import styled from 'styled-components'

export const Image = styled.img`
  width: 100%;
  height: 289px;
  object-fit: content;
`
